import * as React from 'react'
import StoryblokService from 'utils/storyblok-service'
import ContentComponent from './Content'

export const transformProps = (propsArg) => ({
  ...propsArg,
  content: StoryblokService?.client?.richTextResolver?.render(propsArg.content),
})
const Content = (props) => <ContentComponent {...transformProps(props)} />

export default Content
